<template>
	<div id="newsDetail">
		<div class="newsbar"></div>
		<div class="main">
			<h2>{{ info.title }}</h2>
			<div class="toolbar">
				<div class="">来源：{{ info.newsource}}</div>
				<div style="margin-left: 80px;">发布：{{ info.newstime}}</div>
			</div>
			<div class="content" v-html="info.content">
				
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		metaInfo() {
			return {
				meta: [{
						name: 'renderer',
						content: 'http://www.ax168.com/newsDetail'
					},
					{
						name: 'newsDetail',
						content: '新闻详情。'
					},
					{
						name: 'keywords',
						content: '智慧农贸,智慧市场，智慧菜场，电子追溯，电子支付，智慧农贸,数字农贸,智慧农贸市场,智慧城市,菜篮子,农贸市场管理,农贸市场管理系统,溯源单子秤,智慧菜场,智慧菜市场,智慧市场,农贸市场智慧化建设方案,智慧微菜场,农贸市场管理软件,智慧农贸电子秤,农贸市场管理软件,菜市场管理系统,菜市场管理软件,新型农贸市场,O2O菜场，重要产品追溯系统,智慧农贸信息化平台,食品追溯监管系统,企业产品追溯系统,农产品追溯系统,仓储配送系统,智慧支付系统'
					},
					{
						name: 'description',
						content: '浙江安宣信息技术有限公司，国家高新技术企业，咨询热线0571-87357305，智慧菜场、智慧农贸、智慧农批、智慧市场、食品安全信息化监管和食品安全追溯平台以及农贸O2O电商平台。'
					}
				]
			}
		},
		data() {
			return {
				info:{},
				id: ''
			}
		},
		activated() {
			document.documentElement.style.fontSize = "";
		},
		created() {
			console.log(this.$route);
			this.id = this.$route.query.id;
			this.getNewsDetail()
		},
		mounted: function() {
			
		},
		methods: {
			getNewsDetail() {
				let th = this;
				let link = this.GLOBAL.serviceaddress + 'news/queryNewsinfoById.do'
				$.ajax({
					method: 'post',
					url: link,
					data: {
						id: th.id,
					},
				}).then(res => {
					if(res.resultCode == '000000') {
						th.info = res.body;
					}
				})
			}
		},
		
	}
</script>

<style>
	@import url('../css/news.css');
	[v-cloak] {
		display: none !important;
	}
</style>


// WEBPACK FOOTER //
// src/components/news_detail.vue